var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 60,
    viewBox: "0 0 89 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95846 1.75633C3.83072 -1.88796 -3.83974 22.0751 14.4037 22.075C27.2734 20.2516 41.9457 23.1481 49.9193 32.3331C51.2036 33.8128 53.235 37.1605 53.8343 39.0378C59.0147 55.2863 30.3596 51.101 38.8076 37.6407C39.7816 36.0889 41.6594 34.6896 43.3357 33.9416C56.6854 27.985 72.6793 41.393 80.1048 48.9461C81.8748 50.746 86.798 55.421 86.0665 58.5501C86.0216 58.7446 86.3176 55.3423 85.7642 53.885C85.6367 53.5506 85.057 52.7781 85.4277 52.8626C86.5499 53.1184 88.3886 57.569 87.1904 58.5365C86.7083 58.9256 82.4713 55.9371 82.0306 55.7377",
    stroke: "#F3AA47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIn);
export default __webpack_public_path__ + "static/media/arrow-down-in.ab2f5f82577f59a953ae5ee8803eba01.svg";
export { ForwardRef as ReactComponent };